import React from 'react';
import { useDispatch } from 'react-redux';

import { SwitchInput } from 'common/react/components/SwitchInput';
import { getTranslation } from 'common/react/utils/translations';
import { setLeaderboardStateItem } from 'common/store/modules/player-awards/leaderboard';

export const ShowPredicted = () => {
    const dispatch = useDispatch();

    return (
        <div className="brownlow-leaderboard__show-predicted-toggle">
            <SwitchInput
                id={getTranslation('label.showPredicted')}
                label={getTranslation('label.showPredicted')}
                isChecked={true}
                onChange={(inputValue) => {
                    dispatch(
                        setLeaderboardStateItem({
                            item: 'showPredicted',
                            value: inputValue
                        })
                    );
                }}
            />
        </div>
    );
};
